import React, { FC } from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import NavigatorButton from './NavigatorButton';
import NavigatorButtonMobile from './NavigatorButton/NavigationButtonMobile';

import { useBreakpointV2 } from '@helpers/use';
import useBundleCourseModal from '@hooks/bundle/useBundleCourseModal';

type BundleCoursePanelProps = {
  currentIndex: number;
  setCurrentIndex: (currentIndex: number) => void;
};

const BundleCoursePanel: FC<BundleCoursePanelProps> = ({ currentIndex, setCurrentIndex }) => {
  const { t } = useTranslation('store_course');
  const theme = useTheme();
  const { isMobile } = useBreakpointV2();

  const { getTotalIndex, hasNextIndex, hasPreviousIndex, nextIndex, previousIndex } = useBundleCourseModal(
    currentIndex,
  );

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        margin: '0 auto',
        marginTop: { xs: '21px', md: '41px', lg: '34px' },
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '16px',
      }}
    >
      <NavigatorButton
        direction="LEFT"
        isDisabled={!hasPreviousIndex()}
        ariaLabel="prev"
        action={() => previousIndex(setCurrentIndex)}
      />
      <Box
        sx={{
          width: '171px',
          display: 'flex',
          alignItems: 'center',
          backgroundColor: theme.palette.common.white,
          padding: { md: '12px 28px' },
          filter: 'drop-shadow(0px 3px 6px rgba(0, 0, 0, 0.16))',
          borderRadius: '49px',
          border: '1px solid',
          borderColor: 'rgba(0, 0, 0, 0.12)',
        }}
      >
        <NavigatorButtonMobile
          direction="LEFT"
          isDisabled={!hasPreviousIndex()}
          ariaLabel="prev"
          action={() => previousIndex(setCurrentIndex)}
        />
        <Typography variant="h6" sx={{ mx: 'auto' }}>
          {isMobile
            ? t('bundle_detail.bundle_course_items.course.control_panel.title.mobile', {
                currentIndex: currentIndex + 1,
                totalIndex: getTotalIndex(),
              })
            : t('bundle_detail.bundle_course_items.course.control_panel.title', {
                currentIndex: currentIndex + 1,
                totalIndex: getTotalIndex(),
              })}
        </Typography>
        <NavigatorButtonMobile
          direction="RIGHT"
          isDisabled={!hasNextIndex()}
          ariaLabel="next"
          action={() => nextIndex(setCurrentIndex)}
        />
      </Box>
      <NavigatorButton
        direction="RIGHT"
        isDisabled={!hasNextIndex()}
        ariaLabel="next"
        action={() => nextIndex(setCurrentIndex)}
      />
    </Box>
  );
};

export default BundleCoursePanel;
